import "./OurClasses.module.css";
import Header from "@/reusable_sections/Header";
import AcademicPathways from "./sections/AcademicPathways";
import MembershipPaths from "./sections/MembershipPaths";
import CommonQuestions from "./sections/CommonQuestions";
import TheFoundationFooter from "@/reusable_sections/Footer";
export default function OurClassesPage() {
  return <div>
      <Header />
      <AcademicPathways />
      <MembershipPaths />
      <CommonQuestions />
      <TheFoundationFooter />
    </div>;
}